/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { ComponentItemFilterMapper } from './component-item-filter.mapper';
import { ComponentItemFinderListItemDto } from './component-item-finder-list-item.dto';
import { ComponentItemFinderListItemMapper } from './component-item-finder-list-item.mapper';
import { ComponentItemFilterMode } from './component-item-type.enum';

export class ComponentItemFilter {
  constructor(
    public searchType: ComponentItemFilterMode,
    public searchString?: string) {
  }
}

@Injectable()
export class ComponentItemFinderRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  findAllAsDataSource(filter: ComponentItemFilter): SlicedDataSource<ComponentItemFinderListItemDto> {
    return this.createSlicedDataSourceGet(
      `${this.bp}/items-and-components`,
      filter,
      ComponentItemFilterMapper,
      arrayOf(ComponentItemFinderListItemMapper),
    );
  }
}
